module.exports = __webpack_public_path__ + "static/media/ShortText.dbbe6344.svg";